module.exports = __webpack_public_path__ + "img/ico-monitoring-activity.503fbb3c.svg";